'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import LoadingDots from '@/components/commerce/loading-dots';
import Cookies from 'js-cookie';
import Check from '../icons/Check';

export default function AddToCartToastBody({
  product,
  variant,
  additionalProducts,
  gwp,
  checkoutUrl
}) {
  // product object is different between PDP cross sell and interstitial cross sell items
  // product for interstitial is first interstitial product, for cross sell it's the PDP product

  const additionalProductTitle = additionalProducts[0]?.variant?.productTitle
    ? additionalProducts[0]?.variant?.productTitle
    : additionalProducts[0]?.product.title
      ? additionalProducts[0]?.product.title
      : additionalProducts[0]?.variant?.title;

  const plusProductsMessage =
    additionalProducts?.length + gwp?.length > 1
      ? `+${additionalProducts?.length + gwp?.length} more items`
      : gwp?.length == 1
        ? `+Free Gift - ${gwp[0].customAttributes?.find((attribute) => attribute?.key === '_productTitle')?.value}`
        : additionalProducts?.length == 1
          ? `+ ${additionalProductTitle}`
          : null;

  return (
    <div className="pt-2 pr-2 pb-4 pl-4">
      <div className="flex items-start">
        <div className="flex-1 pt-1 pr-9">
          <div className="mb-3 flex items-center">
            <Check className="mr-1" />
            <p className="sh10">Added to Cart</p>
          </div>
          <div className="flex items-center bg-white p-3">
            <div className="mr-4">
              <Image
                src={variant.image.url}
                alt={product.title}
                height="48"
                width="48"
                sizes="48px"
              />
            </div>
            <div>
              <p className="body-s">{product.title}</p>
              <p className="body-xs text-dark-grey-text">{variant.title}</p>
            </div>
          </div>
          {plusProductsMessage && (
            <div className="body-s pt-2">{plusProductsMessage}</div>
          )}
          <div className="grid grid-cols-2 gap-3 pt-4">
            <ViewCartButton href="/cart">View Cart</ViewCartButton>
            <CheckoutButton checkoutUrl={checkoutUrl}>Checkout</CheckoutButton>
          </div>
        </div>
      </div>
    </div>
  );
}

const buttonStyles =
  'inline-block px-8 py-2 bg-transparent text-parlor-green btn-s border border-parlor-green whitespace-nowrap transition-colors duration-150 leading-[22px] hover:text-white hover:bg-parlor-green-80 hover:border-parlor-green-80';

function ViewCartButton({ children, className }) {
  return (
    <Link
      href="/cart"
      className={`${buttonStyles} ${className}`}
      prefetch={false}
    >
      {children}
    </Link>
  );
}

function CheckoutButton({ children, className, checkoutUrl }) {
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleCheckout = async () => {
    if (!checkoutUrl) return;

    setLoading(true);

    try {
      // Append discount code from cookies if applicable
      const discountCode = Cookies.get('lsa-cupc');
      const destination = discountCode
        ? `${checkoutUrl}&discount=${discountCode}`
        : checkoutUrl;

      router.push(destination);
    } catch (error) {
      console.error('Checkout error:', error);
      setLoading(false);
    }
  };

  return (
    <button
      className={`${buttonStyles} w-full ${className}`}
      onClick={handleCheckout}
      disabled={loading || !checkoutUrl}
    >
      {loading ? <LoadingDots className="bg-white" /> : children}
    </button>
  );
}
